import type { ReactElement } from 'react'
import { Link } from '@tanstack/react-router'
import { NOT_FOUND_HEADING, type NavModel } from '../nav/model'
import { Page } from './Page'
import { Panel } from './Panel'

/** The page for an address no route matches (#856), and for a record the URL
 *  names that does not exist (`what="Season"`). Every app's router renders it
 *  as `defaultNotFoundComponent`, inside the app shell. The shell's tab title
 *  reads "Page not found" from the router's not-found match (useIsNotFound). */
export function NotFoundPage({ what = 'Page', home }: { what?: string; home: { to: string; label: string } }) {
  return (
    <Page title={what === 'Page' ? NOT_FOUND_HEADING : `${what} not found`}>
      <Panel className="mx-auto max-w-lg p-8 text-center">
        <p className="mb-5 text-sm text-ink-soft">
          There's no page at this address. The link may be mistyped, or the page may have moved.
        </p>
        <Link to={home.to} className="btn-secondary">
          {home.label}
        </Link>
      </Panel>
    </Page>
  )
}

/** An app's `defaultNotFoundComponent`: the not-found page linking to its home. */
export function notFoundPageFor(m: Pick<NavModel, 'app'>): () => ReactElement {
  return function AppNotFound() {
    return <NotFoundPage home={{ to: '/', label: `Back to Region 13 ${m.app}` }} />
  }
}
